import * as actionTypes from './actionTypes';
import { RecoverPasswordModel } from '@app/src/views/Login/login/models/RecoverPassword';

interface State {
  data: RecoverPasswordModel,
  errorMessage: string,
  isFetching: boolean
}

const initialState: State = {
  data: {
    code: null,
    message: '',
    data: []
  },
  errorMessage: '',
  isFetching: false
};

export const recoverPassword = (state: State = initialState, action): State => {
  switch(action.type) {
    case actionTypes.FETCH_RECOVER_PASSWORD_REQUEST:
      return {
        ...state,
        isFetching: true
      };
    case actionTypes.FETCH_RECOVER_PASSWORD_FAILURE:
      return {
        ...state,
        errorMessage: action.errorMessage,
        isFetching: false
      };
    case actionTypes.FETCH_RECOVER_PASSWORD_SUCCESS:
      return {
        ...state,
        errorMessage: '',
        data: action.data,
        isFetching: false
      };
    default:
      return state;
  }
}
